module.exports = __webpack_public_path__ + "carousel_01_img_04.jpg?197b55a00952c42693e4e813f378ce57";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel_01_img_04.jpg
// module id = 144
// module chunks = 0